export const PROVIDER_CALENDAR_ROUTES = {
  get: '/hlx/provider-calendar',
};

// [MCV-1821] The provider's own pending and active contracts, by start date.
export const PROVIDER_CALENDAR_CONTRACTS_ROUTES = {
  get: '/hlx/provider-calendar/contracts',
};

export const PROVIDER_CALENDAR_BULK_ROUTES = {
  post: '/hlx/provider-calendar/days/bulk',
};

export const PROVIDER_CALENDAR_DAY_ROUTES = {
  delete: '/hlx/provider-calendar/days/{date}',
  put: '/hlx/provider-calendar/days/{date}',
};

export const PROVIDER_CALENDAR_BATCH_REPLACE_ROUTES = {
  post: '/hlx/provider-calendar/days/batch-replace',
};

export const PROVIDER_CALENDAR_RULES_ROUTES = {
  get: '/hlx/provider-calendar/rules',
  post: '/hlx/provider-calendar/rules',
};

export const PROVIDER_CALENDAR_RULE_ROUTES = {
  delete: '/hlx/provider-calendar/rules/{ruleId}',
  patch: '/hlx/provider-calendar/rules/{ruleId}',
};

export const PROVIDER_CALENDAR_RULE_EXCEPTION_ROUTES = {
  post: '/hlx/provider-calendar/rules/{ruleId}/exceptions',
};
